import React, { useEffect } from "react";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import TextExperience from "./TextExperience";
import Aos from "aos";
import "aos/dist/aos.css";

export default function ExperienceBody() {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <div className="flex h-full gap-4 overflow-y-auto" data-aos="fade-up">
      <div className="hidden md:flex w-1/6 md:w-1/5 justify-end">
        <IoArrowForwardCircleOutline className="text-3xl md:text-6xl lg:text-[70px] text-white mt-1" />
      </div>
      <div className="md:w-4/5 sm:mx-4  md:mx-4 lg:mr-64">
        <p className="text-3xl md:text-6xl lg:text-[80px] mb-6 md:mb-14 text-white font-bold">
          Experience
        </p>
        <div className="gap-y-10">
          <TextExperience
            date={"Aug 2025 - Present"}
            company={"PT Astra International Tbk"}
            title={"NodeJS Developer"}
            details={
              "- Develop and maintain backend applications using Node.js with the NestJS framework.\n" +
              "- Implement Redis for caching, session management, and performance optimization.\n" +
              "- Utilize Kafka as a message broker to build event-driven and scalable microservices.\n" +
              "- Design, manage, and optimize relational databases using SQL Server.\n" +
              "- Ensure application scalability, performance, and reliability through best coding practices.\n" +
              "- Collaborate with cross-functional teams to deliver high-quality software solutions.\n" +
              "- Designed and optimized n8n automation flows to enhance ERP system connectivity, streamline data exchange, and improve business process efficiency.\n" +
              "- Troubleshoot, debug, and optimize backend processes and services."
            }
          />
          <TextExperience
            date={"Jul 2025 - Sept 2025"}
            company={"Dr. Soekarjo Hospital, Tasikmalaya City"}
            title={"Full Stack Developer"}
            details={
              "- Developed a blood donation administration system to support hospital operations.\n" +
              "- Built both frontend and backend using Next.js.\n" +
              "- Designed and managed the database with MongoDB for secure and efficient data storage."
            }
          />
          <TextExperience
            date={"Jul 2024 - Aug 2025"}
            company={"PT IFCA Property365 Indonesia"}
            title={"Full Stack Developer"}
            details={
              "- Develop and manage the user interface of web applications using React.js and Angular.js.\n" +
              "- Build and maintain server-side applications using Node.js.\n" +
              "- Design and manage databases using PostgreSQL with TypeORM.\n" +
              "- Implement GraphQL APIs for integration with the frontend.\n" +
              "- Develop and integrate third-party payment gateway solutions to support seamless transactions.\n" +
              "- Implement automation applications to optimize workflows and improve system efficiency."
            }
          />
          <TextExperience
            date={"Aug 2023 - Dec 2023"}
            company={"PT Len Industri (Persero)"}
            title={"Front End Developer"}
            details={
              "- Developed and maintained frontend features using React.js, Tailwind CSS, and Redux.\n" +
              "- Implemented WebSocket integration to support real-time data updates.\n" +
              "- Contributed to a Micro Frontend architecture for scalable application development.\n" +
              "- Collaborated with the team in an Agile/Scrum environment, completing assigned tasks within sprints."
            }
          />
          <TextExperience
            date={"Sep 2023 - Dec 2023"}
            company={"SD Islam Terpadu INSPIRATIF Bojongsari"}
            title={"Front End Developer"}
            details={
              "- Developed a student and teacher administration website to support school operations.\n" +
              "- Built responsive UI using React.js and Tailwind CSS.\n" +
              "- Collaborated with UI/UX designers to translate wireframes into functional interfaces.\n" +
              "- Worked with the Backend team to implement data fetching and API integration for seamless system function."
            }
          />
        </div>
      </div>
    </div>
  );
}
